import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const ReviewsIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-4 w-4 shrink-0", className)}
      viewBox="0 0 16 16"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M8.00667 16C7.68667 16 7.36667 15.8851 7.11333 15.6553L4.61333 13.5192H2.66667C1.19333 13.5192 0 12.3093 0 10.8154V2.70384C0 1.20997 1.19333 0 2.66667 0H13.3333C14.8067 0 16 1.20997 16 2.70384V10.8154C16 12.3093 14.8067 13.5192 13.3333 13.5192H11.4333L8.86667 15.6688C8.62667 15.8851 8.31333 16 8.00667 16ZM2.66667 1.35192C1.93333 1.35192 1.33333 1.96029 1.33333 2.70384V10.8154C1.33333 11.5589 1.93333 12.1673 2.66667 12.1673H4.86C5.02 12.1673 5.16667 12.2214 5.28667 12.3295L7.98667 14.6346L10.7667 12.3228C10.8867 12.2214 11.0333 12.1673 11.1933 12.1673H13.3333C14.0667 12.1673 14.6667 11.5589 14.6667 10.8154V2.70384C14.6667 1.96029 14.0667 1.35192 13.3333 1.35192H2.66667ZM6.00667 10.376C5.88 10.376 5.74667 10.3354 5.64 10.2543C5.43333 10.0989 5.34667 9.82172 5.42667 9.57161L6 7.70596L4.54667 6.50951C4.35333 6.34052 4.28 6.07013 4.36667 5.82679C4.45333 5.58344 4.68667 5.42121 4.94 5.42121H6.77333L7.42 3.65695C7.50667 3.4136 7.74 3.25137 7.99333 3.25137C8.24667 3.25137 8.48 3.4136 8.56667 3.65695L9.21333 5.42121H11.0467C11.3 5.42121 11.5333 5.58344 11.62 5.82679C11.7067 6.07013 11.6333 6.34728 11.44 6.51627L9.99333 7.71272L10.5933 9.55809C10.6733 9.8082 10.5933 10.0853 10.3867 10.2408C10.18 10.403 9.9 10.4098 9.68 10.2678L8 9.15927L6.34667 10.2814C6.24667 10.349 6.12667 10.3828 6.00667 10.3828V10.376Z"
      fill={fill}
    />
    </svg>
  );
};

export default ReviewsIcon;
